import { UserState } from "@/@types/vuex";

export default {
  allUsers: {},
  tmUsers: {},
} as UserState;
